import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
    templateUrl: './invalidSession.component.html',
    styleUrls: ['./invalidSession.component.scss'],
    standalone: false
})

export class InvalidSessionComponent {
  currentDate: Date
  isMobileAFB: boolean;
  mobileAppRidpUser = sessionStorage.getItem('isMobileUser') === 'true' ? true : false;
  constructor(
    private titleService: Title
  ) {
    this.currentDate = new Date();
    this.titleService.setTitle('Unable to Signin');
    this.isMobileAFB = sessionStorage.getItem('isMobileAFB') === 'true' ? true : false; 
  }

}
